interface AddressObject {
  companyName?: string;
  addressLine?: string;
  postCode?: string;
  city?: string;
}

export const addressLine = (addressObject: AddressObject): string => {
  if (!addressObject) {
    return '';
  }
  return [
    addressObject.companyName,
    addressObject.addressLine,
    addressObject.postCode,
    addressObject.city
  ]
    .filter((elt): elt is string => !!elt)
    .join(', ');
};

export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
